// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1bXcf","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__MIkIs"};